module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/american-express_88e736.png";